import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import classNames from "classnames";
import { EmptyState } from "@toddle-edu/ds-web";
import { ChatIllustration } from "@toddle-edu/ds-theme";
import { useI18n } from "Hooks";
import {
  getFormattedNameForUserType,
  CHAT_TYPE,
  getIsMessagingWidget,
} from "MessagingV2/modules/Utils";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import { connect } from "react-redux";
import { useChatOptions } from "MessagingV2/providers/ChatOptionsProvider";

import classes from "./EmptyChatContainer.scss";

const styles = {
  emptySubtitleStyle: {
    width: "600px",
  },
  widgetEmptySubtitleStyle: {
    width: "auto",
  },
};

const EmptyChatContainer = props => {
  const {
    users,
    defaultNameSortPreference,
    chatType,
    channelLabel,
    description,
    defaultStudentNameOrderPreference,
  } = props;
  const { screenMode } = useChatOptions();
  const isWidget = getIsMessagingWidget({ screenMode });

  const { t } = useI18n(["common"]);
  const firstUser = _.first(users);
  const userName =
    firstUser &&
    getFormattedNameForUserType({
      user: firstUser,
      orderBy: defaultNameSortPreference,
      defaultStudentNameOrderPreference,
      isFormattedNameV2: true,
    });

  const getEmptyStateTitle = () => {
    switch (chatType) {
      case CHAT_TYPE.CHANNEL:
        return (
          <div className={classes.textDefault}>
            {!_.isEmpty(description) ? (
              description
            ) : (
              <Trans i18nKey="common:channel_conversation_beginning_with_label">
                <span
                  className={classNames("text-label-2", classes.textDefault)}
                >
                  {{ label: channelLabel }}
                </span>
              </Trans>
            )}
          </div>
        );
      case CHAT_TYPE.CHAT:
        return t("common:chat_conversation_beginning", {
          name: userName,
        });
      case CHAT_TYPE.BOT:
        break;
    }
  };

  return (
    <div className={classes.emptyContainer}>
      <div className={classes.scrollSafeWrapper}>
        <EmptyState
          illustration={ChatIllustration}
          title={t("common:welcome_exclamation")}
          subtitle={getEmptyStateTitle()}
          dsVersion="2.0"
          subtitleStyle={
            isWidget
              ? styles.widgetEmptySubtitleStyle
              : styles.emptySubtitleStyle
          }
        />
      </div>
    </div>
  );
};

EmptyChatContainer.propTypes = {
  chatType: PropTypes.string.isRequired,
  users: PropTypes.array,
};

const mapStateToProps = state => {
  const defaultNameSortPreference = getDefaultNameSortPreference(state);
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  return {
    defaultNameSortPreference,
    defaultStudentNameOrderPreference,
  };
};

export default connect(mapStateToProps)(EmptyChatContainer);
